import { render } from "./OverlayDialog.vue?vue&type=template&id=1f950a34&scoped=true&ts=true"
import script from "./OverlayDialog.vue?vue&type=script&lang=ts"
export * from "./OverlayDialog.vue?vue&type=script&lang=ts"

import "./OverlayDialog.vue?vue&type=style&index=0&id=1f950a34&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f950a34"]])

export default __exports__